import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { config } from "../config";

// Define a service using a base URL and expected endpoints
export const trailApi = createApi({
  reducerPath: "trailApi",
  baseQuery: fetchBaseQuery({
    baseUrl: config.base_url,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("token");
      headers.set("Access-Control-Allow-Origin", "*");
      headers.set("Authorization", "Bearer " + token);
      return headers;
    },
  }),
  // global configuration for the api
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    addTrail: builder.mutation({
      query: (trail) => {
        return {
          url: "/add-trail",
          method: "post",
          body: trail,
        };
      },
    }),
    updateTrail: builder.mutation({
      query: (trail) => {
        return {
          url: "/update-trail",
          method: "post",
          body: trail,
        };
      },
    }),
    deleteTrail: builder.mutation({
      query: (trailId) => {
        return {
          url: "/delete-trail?trail_id=" + trailId,
          method: "post",
        };
      },
    }),
    getMyTrails: builder.query({
      query: (data) => {
        const { searchKey, location } = data;
        console.log("API Data: ", data);
        // const trailQ = "/my-trail?" + "location=" + location;
        let trailQ = "/my-trail";
        if (searchKey !== undefined && searchKey !== "" && searchKey !== null) {
          return trailQ + "&serach_key=" + searchKey;
        }
        return trailQ;
      },
    }),
    getMyTrailGroup: builder.query({
      query: (data) => {
        console.log("API DATA: ", data);
        const { searchKey, location } = data;
        // const trailQ = "/my-trail-group?" + "location=" + location;
        let trailQ = "/my-trail-group";
        // add user_id get favorite trails and trail related stuff ::start 
        const user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : "";
        if (user) trailQ += "?user_id=" + user.id;
        // add user_id get favorite trails and trail related stuff ::end 
        if (searchKey !== undefined && searchKey !== "" && searchKey !== null) {
          let getTrailsQuery = "/get-trails?" + "location=" + location + "&serach_key=" + searchKey;
          if (user) getTrailsQuery += "&user_id=" + user.id;
          return getTrailsQuery;
        }
        return trailQ;
      },
      keepUnusedDataFor: 5,
    }),
    getViewTrailGroup: builder.query({
      // query: (id) => "/view-trail-group?group_id=" + id,
      query: (data) => {
        let query = "/view-trail-group?group_id=" + data.id;
        if (data.searchText !== "" && data.searchText !== undefined && data.searchText !== null) {
          query += "&serach_key=" + data.searchText
        }
        // add user_id get favorite trails and trail related stuff ::start 
        const user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : "";
        if (user) query += "&user_id=" + user.id;
        // add user_id get favorite trails and trail related stuff ::end
        return query;
      }
      // (data.searchText !== "" && data.searchText !== undefined && data.searchText !== null ? "/view-trail-group?group_id=" + data.id + "&serach_key=" + data.searchText : "/view-trail-group?group_id=" + data.id),
    }),
    addCustomTrail: builder.mutation({
      query: (userData) => {
        return {
          url: "/custom-trail",
          method: "post",
          body: userData,
        };
      },
    }),
    addThruhikeConcierge: builder.mutation({
      query: (userData) => {
        return {
          url: "/concierges",
          method: "post",
          body: userData,
        };
      },
    }),
    getTrailsPosts: builder.query({
      query: (data) => {
        const user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : "";

        // let query = "/view-trail-post?slug=" + data.id + "&location=" + data.location;
        let query = "/view-trail-post?slug=" + data.id;
        if (user) query += "&user_id=" + user.id;
        if (data.searchText && data.searchText !== "" && data.searchText !== undefined) {
          if (data.searchText.includes("#")) {
            return query + "&tag=" + data.searchText.substring(1, data.searchText.length);
          } else {
            return query + "&serach_key=" + data.searchText;
          }
        } else {
          return query;
        }
      },
    }),
    favouriteTrail: builder.mutation({
      query: (data) => {
        return {
          url: "/favourite-trail",
          method: "post",
          body: data,
        };
      },
    }),
    unFavouriteTrail: builder.mutation({
      query: (data) => {
        return {
          url: "/un-favourite-trail",
          method: "post",
          body: data,
        };
      },
    }),
    favouritePost: builder.mutation({
      query: (data) => {
        return {
          url: "/favourite-post",
          method: "post",
          body: data,
        };
      },
    }),
    unFavouritePost: builder.mutation({
      query: (data) => {
        return {
          url: "/un-favourite-post",
          method: "post",
          body: data,
        };
      },
    }),
    addTrailPost: builder.mutation({
      query: (data) => {
        return {
          url: "/add-trail_post",
          method: "post",
          body: data,
        };
      },
    }),
    getSuggestedTrails: builder.query({
      query: (data) => {
        const { searchKey, location } = data;
        console.log("API Data: ", data);
        // const trailQ = "/suggest-trail?" + "location=" + location;
        const trailQ = "/suggest-trail";
        if (searchKey !== undefined && searchKey !== "" && searchKey !== null) {
          return trailQ + "&serach_key=" + searchKey;
        }
        return trailQ;
      },
    }),
    deleteTrailPost: builder.mutation({
      query: (data) => {
        return {
          url: "/delete-trail_post",
          method: "post",
          body: data,
        };
      },
    }),
    upVoteTrail: builder.mutation({
      query: (data) => {
        return {
          url: config.base_url + "trail-up-vote",
          method: "post",
          body: data,
        };
      },
    }),
    downVoteTrail: builder.mutation({
      query: (data) => {
        return {
          url: config.base_url + "trail-down-vote",
          method: "post",
          body: data,
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useUpVoteTrailMutation, useDownVoteTrailMutation, useAddTrailMutation, useUpdateTrailMutation, useDeleteTrailMutation, useGetMyTrailsQuery, useGetMyTrailGroupQuery, useGetViewTrailGroupQuery, useAddCustomTrailMutation, useAddThruhikeConciergeMutation, useGetTrailsPostsQuery, useFavouriteTrailMutation, useUnFavouriteTrailMutation, useFavouritePostMutation, useUnFavouritePostMutation, useAddTrailPostMutation, useGetSuggestedTrailsQuery, useDeleteTrailPostMutation } = trailApi;
